import React from 'react';
import {
    Platform,
    Image,
    StyleSheet
} from "react-native";

const Icon = ({ iconSource, imagePropStyle }) => {
    return (
        <Image
            source={iconSource}
            style={[styles.iconStyle, imagePropStyle]}
            resizeMode={'contain'}
        />
    )
};

const styles = StyleSheet.create({
   iconStyle: {
       width: 32,
       height: 32,
       marginLeft: 16,
   }
});

export { Icon };
